import { CAT_PALETTES, mascotSVG } from '../cat/cat.js';
import { state } from '../core/state.js';
import { $, $$, dayKey, esc } from '../core/text.js';
import { ADV_PETS } from '../game/data.js';
import { streakDays } from '../progress/streak.js';
import { ACCESSORIES, ACHIEVEMENTS, IC, accById, accUnlocked, buddyMarkup, levelInfo, renderBuddy, renderCurrency, saveProgress } from '../progress/xp.js';
import { confetti } from '../ui/confetti.js';
import { SFX, toast } from '../ui/toast.js';

/* ══════════ Shop & Katzenzimmer ══════════ */
export const FURNITURE = [
  { key: 'rug',        name: 'Teppich',        img: 'assets/room_rug.png',        coins: 120, gems: 0 },
  { key: 'lamp',       name: 'Stehlampe',      img: 'assets/room_lamp.png',       coins: 90,  gems: 0 },
  { key: 'nightstand', name: 'Nachttisch',     img: 'assets/room_nightstand.png', coins: 80,  gems: 0 },
  { key: 'plantstand', name: 'Pflanzentisch',  img: 'assets/room_plantstand.png', coins: 110, gems: 0 },
  { key: 'desk',       name: 'Schreibtisch',   img: 'assets/room_desk.png',       coins: 150, gems: 0 },
  { key: 'shelf',      name: 'Bücherregal',    img: 'assets/room_shelf.png',      coins: 220, gems: 0 },
  { key: 'armchair',   name: 'Sessel',         img: 'assets/room_armchair.png',   coins: 260, gems: 0 },
  { key: 'bed',        name: 'Bett',           img: 'assets/room_bed.png',        coins: 300, gems: 0 },
  { key: 'wallshelf',  name: 'Wandregal',      img: 'assets/room_wallshelf.png',  coins: 0,   gems: 1 },
  { key: 'dresser',    name: 'Kommode',        img: 'assets/room_dresser.png',    coins: 0,   gems: 2 },
];
export const furnByKey = (k) => FURNITURE.find((f) => f.key === k);
export const owns = (k) => state.progress.owned.includes(k);
export const priceLabel = (f) => [f.coins ? `${f.coins} 🪙` : '', f.gems ? `${f.gems} 💎` : ''].filter(Boolean).join(' + ');

export async function buyItem(key) {
  const f = furnByKey(key); const p = state.progress;
  if (!f || owns(key)) return;
  if ((p.coins || 0) < f.coins || (p.gems || 0) < f.gems) { toast('Dafür reicht dein Guthaben noch nicht'); return; }
  p.coins -= f.coins; p.gems -= f.gems;
  p.owned.push(key);
  // ins Zimmer legen (Startposition versetzt)
  const n = p.room.length;
  p.room.push({ key, x: 12 + (n % 4) * 21, y: 20 + Math.floor(n / 4) * 30 });
  await saveProgress();
  SFX.unlock(); confetti(); toast(`${f.name} gekauft ✦`);
  renderShop(); renderCurrency();
}
export async function resetRoom() {
  state.progress.room = state.progress.owned.map((key, n) => ({ key, x: 12 + (n % 4) * 21, y: 20 + Math.floor(n / 4) * 30 }));
  await saveProgress(); renderRoom($('#room-stage'), true);
}

/* Katzenfarben & Zimmer-Designs (kaufen → ausrüsten) */
export const CAT_COLORS = [
  { key: 'orange', name: 'Orange', coins: 0, gems: 0 },
  { key: 'grey',   name: 'Grau',   coins: 200, gems: 0 },
  { key: 'cream',  name: 'Creme',  coins: 200, gems: 0 },
  { key: 'night',  name: 'Nacht',  coins: 0, gems: 2 },
];
export const ROOM_THEMES = [
  { key: 'default', name: 'Warm',  coins: 0, gems: 0, wall: '#f3ead6', floor: '#d9c39a' },
  { key: 'mint',    name: 'Minze', coins: 180, gems: 0, wall: '#e7f0e2', floor: '#bcd3ac' },
  { key: 'rose',    name: 'Rosé',  coins: 180, gems: 0, wall: '#f6e6e6', floor: '#e0b9b9' },
  { key: 'dusk',    name: 'Abend', coins: 0, gems: 1, wall: '#e8e3f2', floor: '#c4b8d8' },
];
export const ownsColor = (k) => k === 'orange' || state.progress.ownedColors.includes(k);
export const ownsTheme = (k) => k === 'default' || state.progress.ownedThemes.includes(k);
export const canPay = (it) => (state.progress.coins || 0) >= it.coins && (state.progress.gems || 0) >= it.gems;

export async function buyOrEquip(kind, key) {
  const p = state.progress;
  const list = kind === 'color' ? CAT_COLORS : ROOM_THEMES;
  const it = list.find((x) => x.key === key); if (!it) return;
  const ownedList = kind === 'color' ? p.ownedColors : p.ownedThemes;
  const isOwned = kind === 'color' ? ownsColor(key) : ownsTheme(key);
  if (!isOwned) {
    if (!canPay(it)) { toast('Dafür reicht dein Guthaben noch nicht'); return; }
    p.coins -= it.coins; p.gems -= it.gems; ownedList.push(key);
    SFX.unlock(); confetti(); toast(`${it.name} gekauft ✦`);
  }
  if (kind === 'color') p.catColor = key; else p.roomTheme = key;
  await saveProgress();
  renderShop(); renderBuddy();
}
export async function buyFreeze() {
  const p = state.progress; const cost = 150;
  if ((p.coins || 0) < cost) { toast('Dafür reicht dein Guthaben noch nicht'); return; }
  p.coins -= cost; p.freezes = (p.freezes || 0) + 1;
  await saveProgress(); SFX.unlock(); toast('❄ Streak-Schutz gekauft ✦'); renderShop();
}

export function renderRoom(stage, editable) {
  if (!stage) return;
  const theme = ROOM_THEMES.find((t) => t.key === state.progress.roomTheme) || ROOM_THEMES[0];
  stage.style.setProperty('--wall', theme.wall);
  stage.style.setProperty('--floor', theme.floor);
  stage.classList.add('room-bg');
  const placed = state.progress.room.filter((r) => owns(r.key));
  const cat = `<div class="room-cat">${buddyMarkup('happy')}</div>`;
  if (!placed.length) {
    stage.innerHTML = cat + `<div class="room-empty-pop">
      <div class="rep-spark">✦</div>
      <div class="rep-title">Dein Zimmer wartet auf Möbel</div>
      <div class="rep-text">${editable ? 'Stöbere im Shop und zieh Möbel hierher, um es dir gemütlich zu machen.' : 'Hier wird es gemütlich, sobald Möbel aus dem Shop einziehen.'}</div>
      ${editable ? '<button class="btn-primary rep-btn" id="room-empty-shop"><img src="assets/icon_coin.png" alt="" style="width:18px;vertical-align:-3px"> Zum Shop stöbern</button>' : ''}</div>`;
    const b = stage.querySelector('#room-empty-shop'); if (b) b.onclick = () => toast('Der Shop ist zurzeit deaktiviert.');
    return;
  }
  stage.innerHTML = cat + placed.map((r, i) =>
    `<img class="room-item" data-idx="${i}" src="${furnByKey(r.key).img}" alt="${esc(furnByKey(r.key).name)}"
      style="left:${r.x}%;top:${r.y}%" draggable="false" title="${editable ? 'Ziehen zum Verschieben · Doppelklick zum Entfernen' : ''}">`).join('');
  if (editable) enableRoomDrag(stage);
}
export function enableRoomDrag(stage) {
  stage.querySelectorAll('.room-item').forEach((el) => {
    // Doppelklick: Möbel zurück ins Inventar (aus dem Zimmer nehmen)
    el.ondblclick = async () => {
      const idx = +el.dataset.idx;
      state.progress.room.splice(idx, 1);
      await saveProgress(); renderRoom(stage, true); toast('Möbel zurück ins Inventar');
    };
    el.onpointerdown = (e) => {
      e.preventDefault();
      const idx = +el.dataset.idx;
      const rect = stage.getBoundingClientRect();
      el.setPointerCapture(e.pointerId);
      el.classList.add('dragging');
      const move = (ev) => {
        let x = ((ev.clientX - rect.left) / rect.width) * 100;
        let y = ((ev.clientY - rect.top) / rect.height) * 100;
        x = Math.max(2, Math.min(88, x)); y = Math.max(4, Math.min(84, y));
        el.style.left = x + '%'; el.style.top = y + '%';
        state.progress.room[idx].x = x; state.progress.room[idx].y = y;
      };
      const up = async () => {
        el.classList.remove('dragging');
        el.onpointermove = null; el.onpointerup = null;
        await saveProgress();
      };
      el.onpointermove = move; el.onpointerup = up;
    };
  });
}
export function renderShop() {
  renderCurrency();
  renderRoom($('#room-stage'), true);
  const p = state.progress;
  $('#shop-grid').innerHTML = FURNITURE.map((f) => {
    const owned = owns(f.key);
    const afford = (p.coins || 0) >= f.coins && (p.gems || 0) >= f.gems;
    return `<div class="shop-card ${owned ? 'owned' : ''}">
      <div class="shop-thumb"><img src="${f.img}" alt=""></div>
      <div class="shop-name">${esc(f.name)}</div>
      <div class="shop-price">${priceLabel(f)}</div>
      <button class="btn-primary tiny buy-btn" data-buy="${f.key}" ${owned ? 'disabled' : ''}>${owned ? '✓ Gekauft' : afford ? 'Kaufen' : 'Zu teuer'}</button>
    </div>`;
  }).join('');
  $$('[data-buy]').forEach((b) => { b.onclick = () => buyItem(b.dataset.buy); });
  const rr = $('#btn-room-reset'); if (rr) rr.onclick = resetRoom;

  // Katzenfarben
  if ($('#color-grid')) {
    $('#color-grid').innerHTML = CAT_COLORS.map((cc) => {
      const owned = ownsColor(cc.key), equipped = p.catColor === cc.key;
      const svg = `<svg viewBox="0 0 16 16" width="60" height="60" shape-rendering="crispEdges" style="image-rendering:pixelated">${catSwatchSVG(cc.key)}</svg>`;
      return `<div class="shop-card ${equipped ? 'owned' : ''}">
        <div class="shop-thumb">${svg}</div>
        <div class="shop-name">${esc(cc.name)}</div>
        <div class="shop-price">${owned ? (equipped ? 'aktiv' : 'freigeschaltet') : (priceLabel(cc) || 'gratis')}</div>
        <button class="btn-primary tiny" data-color="${cc.key}" ${equipped ? 'disabled' : ''}>${equipped ? '✓ Aktiv' : owned ? 'Anlegen' : (canPay(cc) ? 'Kaufen' : 'Zu teuer')}</button>
      </div>`;
    }).join('');
    $$('[data-color]').forEach((b) => { b.onclick = () => buyOrEquip('color', b.dataset.color); });
  }
  // Zimmer-Designs
  if ($('#theme-grid')) {
    $('#theme-grid').innerHTML = ROOM_THEMES.map((t) => {
      const owned = ownsTheme(t.key), equipped = p.roomTheme === t.key;
      return `<div class="shop-card ${equipped ? 'owned' : ''}">
        <div class="shop-thumb"><span class="theme-swatch" style="background:linear-gradient(180deg,${t.wall} 55%,${t.floor} 55%)"></span></div>
        <div class="shop-name">${esc(t.name)}</div>
        <div class="shop-price">${owned ? (equipped ? 'aktiv' : 'freigeschaltet') : (priceLabel(t) || 'gratis')}</div>
        <button class="btn-primary tiny" data-theme="${t.key}" ${equipped ? 'disabled' : ''}>${equipped ? '✓ Aktiv' : owned ? 'Anlegen' : (canPay(t) ? 'Kaufen' : 'Zu teuer')}</button>
      </div>`;
    }).join('');
    $$('[data-theme]').forEach((b) => { b.onclick = () => buyOrEquip('theme', b.dataset.theme); });
  }
  // Extras: Streak-Schutz
  if ($('#extra-grid')) {
    $('#extra-grid').innerHTML = `<div class="shop-card">
      <div class="shop-thumb" style="font-size:2.4rem">❄</div>
      <div class="shop-name">Streak-Schutz</div>
      <div class="shop-price">150 🪙 · du hast ${p.freezes || 0}</div>
      <button class="btn-primary tiny" id="buy-freeze" ${(p.coins || 0) < 150 ? 'disabled' : ''}>Kaufen</button>
    </div>`;
    const bf = $('#buy-freeze'); if (bf) bf.onclick = buyFreeze;
  }
}
/* Kleine Farb-Vorschau der Katze (nur Kopf) fürs Shop-Raster */
export function catSwatchSVG(colorKey) {
  const pal = CAT_PALETTES[colorKey] || CAT_PALETTES.orange;
  const r = (x, y, w, h, c) => `<rect x="${x}" y="${y}" width="${w}" height="${h}" fill="${c}"/>`;
  let s = r(3, 2, 1, 3, pal.O) + r(4, 1, 2, 2, pal.F) + r(12, 2, 1, 3, pal.O) + r(10, 1, 2, 2, pal.F);
  const hw = { 3: 5, 4: 6, 5: 6, 6: 6, 7: 6, 8: 6, 9: 6, 10: 5, 11: 4 };
  for (const y in hw) { const w = hw[y]; s += r(8 - w, +y, 2 * w, 1, pal.F); }
  s += r(7, 3, 2, 2, pal.f) + r(4, 8, 8, 3, pal.C);
  s += r(5, 6, 1, 2, '#4a3f38') + r(10, 6, 1, 2, '#4a3f38') + r(7, 8, 2, 1, '#f4a0a8');
  return s;
}

/** Vorschau: Katze (klein) mit einem bestimmten Accessoire – fürs Shop-Raster. */
export function accPreview(accId) {
  return state.buddyImg ? `<img src="${state.buddyImg}" alt="">` : mascotSVG('happy', accId);
}
export function renderAchievements() {
  const info = levelInfo(state.progress.xp);
  $('#buddy-big').innerHTML = buddyMarkup('happy');
  $('#ach-level').textContent = info.level;
  $('#ach-xp-fill').style.width = info.pct + '%';
  const unlocked = state.progress.unlocked.length;
  $('#ach-xp-note').textContent = `${info.inLvl} / ${info.span} XP bis Level ${info.level + 1} · ${state.progress.rated} Karten geübt · ${unlocked}/${ACHIEVEMENTS.length} Erfolge`;

  const accs = [{ id: null, name: 'Ohne' }, ...ACCESSORIES];
  $('#acc-grid').innerHTML = accs.map((a) => {
    const locked = a.id !== null && !accUnlocked(a.id);
    const equipped = (state.progress.equipped || null) === a.id;
    const need = locked ? ACHIEVEMENTS.find((x) => x.acc === a.id) : null;
    return `<button class="acc-card acc-tier-${a.tier || 1} ${locked ? 'locked' : ''} ${equipped ? 'equipped' : ''}" data-acc="${a.id ?? ''}" ${locked ? 'disabled' : ''}>
      <div class="acc-icon">${accPreview(a.id)}</div>
      <div class="acc-name">${esc(a.name)}</div>
      <div class="acc-need">${locked ? '🔒 ' + esc(need?.name || '') : equipped ? '✓ getragen' : 'anlegen'}</div>
    </button>`;
  }).join('');
  $$('[data-acc]').forEach((el) => {
    el.onclick = async () => {
      state.progress.equipped = el.dataset.acc || null;
      await saveProgress(); renderAchievements(); renderBuddy(); SFX.flip();
    };
  });

  const actx = achContext();
  $('#ach-grid').innerHTML = ACHIEVEMENTS.map((a) => {
    const done = state.progress.unlocked.includes(a.id);
    const reward = [a.acc ? 'Accessoire: ' + (accById(a.acc)?.name || '') : '', a.xp ? `+${a.xp} XP` : ''].filter(Boolean).join(' · ');
    const m = ACH_METRIC[a.id];
    let bar = '';
    if (!done && m) {
      const cur = Math.min(actx[m[0]] || 0, m[1]);
      bar = `<div class="ach-bar"><i style="width:${Math.round((cur / m[1]) * 100)}%"></i></div><div class="ach-prog">${cur} / ${m[1]}</div>`;
    }
    return `<div class="ach-card ${done ? 'done' : 'locked'}">
      <img class="ach-ico" src="${IC(a.icon)}" alt="">
      <div class="ach-name">${done ? '✓ ' : ''}${esc(a.name)}</div>
      <div class="ach-need">${esc(a.desc)}${reward ? `<br><span class="ach-reward">${esc(reward)}</span>` : ''}</div>
      ${bar}
    </div>`;
  }).join('');
}
/* Kennzahl + Ziel je Erfolg → Fortschrittsbalken */
export const ACH_METRIC = {
  first: ['rated', 1], warm: ['rated', 10], keep: ['rated', 50], hundred: ['rated', 100],
  machine: ['rated', 250], mage: ['rated', 500], legend: ['rated', 1000], pro: ['rated', 2500], gm: ['rated', 5000],
  combo10: ['bestCorrect', 10], combo25: ['bestCorrect', 25], combo50: ['bestCorrect', 50], combo100: ['bestCorrect', 100],
  unlucky: ['bestWrong', 10], marathon: ['todayCount', 100], regular: ['learnedDays', 30],
  week: ['streak', 7], month: ['streak', 30], century: ['streak', 100],
  lvl10: ['level', 10], lvl20: ['level', 20], lvl50: ['level', 50], lvl100: ['level', 100],
  frnd1: ['friends', 1], frnd5: ['friends', 5], frnd10: ['friends', 10],
  pub1: ['published', 1], pub5: ['published', 5], pub10: ['published', 10],
  like10: ['likesReceived', 10], like50: ['likesReceived', 50], like100: ['likesReceived', 100],
  down50: ['downloads', 50],
  advSect5: ['advSection', 5], advSect10: ['advSection', 10], advSect25: ['advSection', 25],
  advExam1: ['advExams', 1], advExam5: ['advExams', 5],
  advLegend1: ['advLegend', 1], advMax1: ['advMythic', 1], advCollect: ['advItems', 4],
  advItems8: ['advItems', 8], advItems14: ['advItems', 14], advLegend3: ['advLegend', 3],
  advMythic3: ['advMythic', 3], advLvl10: ['advLevel', 10], advLvl25: ['advLevel', 25], advSect50: ['advSection', 50],
  advPet1: ['advPets', 1], advPet5: ['advPets', 5], advPet10: ['advPets', 10], advWorld3: ['advWorlds', 3], advWorld6: ['advWorlds', 6], advSetFull: ['advSetFull', 1],
  advGroup3: ['advGroups', 1], advSquad: ['advBossSquad', 1], advElite: ['advElites', 1],
};
export function advAchFields() {
  const g = state.progress.game || {};
  const items = Object.values(g.items || {});
  return {
    advSection: g.maxSection || 1, advLevel: g.charLvl || 1, advExams: g.examsBeaten || 0,
    advItems: items.filter((i) => i && i.level >= 1).length,
    advLegend: items.filter((i) => i && i.level >= 4).length,
    advMythic: items.filter((i) => i && i.level >= 5).length,
    advPets: Object.keys(g.pets || {}).filter((id) => ADV_PETS[id]).length,
    advWorlds: g.examsBeaten || 0,   // jeder besiegte Boss = eine befreite Welt
    advSetFull: g.setFullEver || 0,
    advGroups: g.groupsBeaten || 0, advBossSquad: g.bossSquadBeaten || 0, advElites: g.elitesBeaten || 0,
  };
}
export function achContext() {
  return {
    rated: state.progress.rated, level: levelInfo(state.progress.xp).level,
    bestCorrect: state.progress.best.correct, bestWrong: state.progress.best.wrong,
    streak: streakDays(), todayCount: state.log.find((l) => l.day === dayKey())?.count || 0,
    learnedDays: state.log.filter((l) => l.count > 0).length,
    friends: state.social.friends || 0, published: state.social.published || 0,
    likesReceived: state.social.likesReceived || 0, downloads: state.social.downloads || 0,
    ...advAchFields(),
  };
}

